import fork from '@haaretz/l-fork.macro';

import type { MiddlewareParams } from '@haaretz/s-types';

export default function countryCodeDispenserMiddleware({ ctx }: MiddlewareParams) {
  const countryCode =
    ctx.req.headers.country_code ||
    fork({
      default:
        /* istanbul ignore next */
        'IL',
      hdc: 'US',
    });
  ctx.query.countryCode = countryCode;

  return Promise.resolve({ countryCode });
}
